export const DATABASE_UNAVAILABLE_CODE = 'DATABASE_UNAVAILABLE';

const COPY = {
  database: {
    title: 'Banco de dados temporariamente indisponível.',
    description:
      'Não foi possível carregar os dados neste momento. Tente novamente em alguns instantes.',
  },
  databaseStale: {
    title: 'Não foi possível atualizar os dados.',
    description: 'Os dados exibidos podem estar desatualizados.',
  },
  api: {
    title: 'Não foi possível comunicar com o servidor.',
    description: 'Verifique sua conexão ou tente novamente em alguns instantes.',
  },
  apiStale: {
    title: 'Não foi possível atualizar os dados.',
    description: 'Os dados exibidos podem estar desatualizados. Verifique sua conexão.',
  },
};

export function isDatabaseUnavailableError(error) {
  return error?.response?.data?.code === DATABASE_UNAVAILABLE_CODE;
}

export function isApiUnreachableError(error) {
  if (!error || error.response) return false;

  const code = error.code;
  return code === 'ERR_NETWORK' || code === 'ECONNABORTED' || error.message === 'Network Error';
}

export function isInfrastructureError(error) {
  return (
    isDatabaseUnavailableError(error) ||
    error?.response?.status === 503 ||
    isApiUnreachableError(error)
  );
}

export function getApiErrorMessage(error, fallback = 'Erro ao processar a solicitação.') {
  const data = error?.response?.data;

  if (data && typeof data === 'object') {
    if (Array.isArray(data.errors) && data.errors.length > 0) {
      return data.errors.filter(Boolean).join(' ');
    }
    if (typeof data.error === 'string' && data.error) return data.error;
    if (data.error && typeof data.error === 'object') {
      return data.error.aviso || data.error.message || fallback;
    }
    if (typeof data.mensagem === 'string' && data.mensagem) return data.mensagem;
    if (typeof data.message === 'string' && data.message) return data.message;
  }

  return fallback;
}

export function getInfrastructureErrorCopy(error, { stale = false } = {}) {
  if (!isInfrastructureError(error)) return null;

  if (isApiUnreachableError(error)) {
    return stale ? COPY.apiStale : COPY.api;
  }

  return stale ? COPY.databaseStale : COPY.database;
}
